export var LOCATION_PLUGIN_UIDS = {
    APPROXIMATE: 'ctx.flybits.approximateArea',
    PRECISE: 'ctx.flybits.area',
};
export var LOCATION_ATTRIBUTE_UIDS = {
    APPROXIMATE_LIST: 'ctx.flybits.approximateArea.query.inApproximateArea',
    PRECISE_LIST: 'ctx.flybits.area.query.inArea',
    APPROXIMATE_LABELS: 'ctx.flybits.approximateArea.query.inAreaWithLabel',
    PRECISE_LABELS: 'ctx.flybits.area.query.inAreaWithLabel',
};
export var LOCATION_CATEGORY_NAMES = {
    AREA: 'area',
    APPROXIMATE_AREA: 'approximateArea',
};
export var LOCATION_CATEGORY_DISPLAY_NAMES = {
    APPROXIMATE: 'approx-area',
    PRECISE: 'precise-area',
};
export var LOCATION_ATTRIBUTE_NAMES = {
    APPROXIMATE: 'inApproximateArea',
    PRECISE: 'inArea',
    LABELS: 'inAreaWithLabel',
};
export var LOCATION_ATTRIBUTE_DISPLAY_NAMES = {
    LABEL: 'label',
    ADDRESS: 'address',
};
//# sourceMappingURL=location.js.map